import cn from 'clsx';
import { FC } from 'react';

import { ColorPalette } from '../../../types';
import Icon from '../../Icon';

import s from './DetailTotalAmount.module.scss';

type DetailTotalAmountColorType = 'default' | 'red' | 'blue';
type DetailTotalAmountIconType = 'help' | 'info';

interface ContentModel {
  title: string;
  amount: string;
  icon?: DetailTotalAmountIconType;
  color?: DetailTotalAmountColorType;
}

export interface DetailTotalAmountProps {
  contents: ContentModel[];
  className?: string;
}

const ICON_COLOR: Record<DetailTotalAmountColorType, ColorPalette> = {
  default: 'gray.600',
  red: 'red.600',
  blue: 'blue.600'
};

const DetailTotalAmount: FC<React.PropsWithChildren<React.PropsWithChildren<DetailTotalAmountProps>>> = ({ className = '', contents }) => {
  return (
    <div className={cn(s.wrap, className)}>
      {contents.map(({ title, amount, icon, color = 'default' }) => (
        <div key={title} className={cn(s.inner_wrap, s[color])}>
          <p className={s.title}>
            {title}
            {icon && <Icon className={s.icon} type={icon === 'help' ? 'state-help' : 'state-info'} color={ICON_COLOR[color]} size={20} />}
          </p>
          <p className={s.amount_text}>{amount}</p>
        </div>
      ))}
    </div>
  );
};

export default DetailTotalAmount;
